import { render } from "./AddSequence.vue?vue&type=template&id=39788336"
import script from "./AddSequence.vue?vue&type=script&lang=js"
export * from "./AddSequence.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__